module.exports = __webpack_public_path__ + "static/media/background.3bef1650.mp3";